import { Ticket } from '@wix/answers-api';
import { Box, Heading, Collapse, TextButton } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import React, { FunctionComponent, useState } from 'react';

import { MyTicketsList } from './MyTicketsList';
import { DATA_HOOKS } from '../../../dataHooks';

import css from './index.module.scss';

export type MyTicketsProps = {
  tickets: Ticket[];
  ticketsCount: number;
  onShowMoreClick: () => void;
};

export const MyTickets: FunctionComponent<MyTicketsProps> = ({
  tickets,
  ticketsCount,
  onShowMoreClick,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const { t } = useTranslation();
  const toggleCollapse = () => setIsCollapsed(!isCollapsed);

  const hasMore = tickets.length < ticketsCount;
  return (
    <Box
      direction="vertical"
      dataHook={DATA_HOOKS.MY_ACTIVITY_TICKETS}
      className={
        isCollapsed
          ? `${css.collapsedList} ${css.collapsed}`
          : `${css.collapsedList}`
      }
    >
      <Heading
        dataHook={DATA_HOOKS.MY_ACTIVITY_TICKETS_TITLE}
        className={css.ticketsTitle}
        onClick={toggleCollapse}
      >
        <div className={css.toggleArrow} />
        {t('user.my-activity.tickets')}
        <span>({ticketsCount})</span>
      </Heading>
      <Collapse open={!isCollapsed}>
        {tickets.length ? (
          <MyTicketsList tickets={tickets} />
        ) : (
          <p className={css.none}>{t('user.my-activity.no.tickets')}</p>
        )}
        {hasMore ? (
          <TextButton
            dataHook={DATA_HOOKS.MY_ACTIVITY_TICKETS_SHOW_MORE}
            onClick={onShowMoreClick}
            className={css.more}
          >
            {t('user.my-activity.show.more')}
          </TextButton>
        ) : null}
      </Collapse>
    </Box>
  );
};
